import { Component, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-email-html-preview',
  standalone: true,
  encapsulation: ViewEncapsulation.ShadowDom,
  template: ` <div class="email ql-editor" [innerHTML]="html"></div> `,
  styleUrl: './email-html-preview.component.scss'
})
export class EmailHtmlPreviewComponent {
  // html is a plain string Input (never SafeHtml), so Angular auto-sanitizes the [innerHTML]
  // binding above.
  @Input({ required: true }) html: string = '';
}
